import React from 'react';

import { Span, Indicator, Flex } from '@sopranodesign/pulse-components';

const Submitted = () => (
  <Flex center xSpaceSm>
    <Indicator colour="danger" />
    <Span>Submitted</Span>
  </Flex>
);

const InProgress = () => (
  <Flex center xSpaceSm>
    <Indicator colour="warning" />
    <Span>In Progress</Span>
  </Flex>
);

const Resolved = () => (
  <Flex center xSpaceSm>
    <Indicator colour="positive" />
    <Span>Resolved</Span>
  </Flex>
);

const statuses = {
  submitted: Submitted,
  in_progress: InProgress,
  resolved: Resolved
};

const TicketStatus = ({ children: status }) => {
  const Status = statuses[status];

  return <Status />;
};

export default TicketStatus;
